<template>
    <router-link class="ig--content-user row row-center" :to=" item.openid ? `/user/${item.openid}`: $route.fullPath" tag="div">
        <img class="user-avatar" :src="item.iId ? `${ imagePath }/logo.png` : item.head_url && mHttps(decode(item.head_url.replace(/／/g, '/')))" />
        <div class="user-file">
            <div class="file-up row row-bottom">
                <div class="file-name" :style="{ 'color': mColor(2) }" v-text="item.nick_name||item.sAuthor">
                </div>
                <!-- <div class="ig--tag" :style="{ 'border-color': mColor(11), 'color': mColor(11) }" v-if="item.sAuthor">热门</div>                 -->
                <!-- <div class="file-level" :style="{ 'color': color['3'], 'display': 'none' }">
                    至尊星耀
                </div> -->
            </div>
            <div class="file-down file-time" :style="{ 'color': mColor(3) }">
                {{ item.iId ? item.sIdxTime : (item.addtime*1000) | mcFormatTime('M月D日 hh:mm') }}
            </div>
        </div>
    </router-link>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
	name: 'igc--item-user',
    mixins: [mCore],
	props: {
		item: {
			type: Object,
			required: true
		}
	},
    computed: {
        imagePath() {
            return this.$store.getters['global/imagePath']
        }
    },
    methods: {
        decode(val){
            return decodeURIComponent(val+'')
        }
    },
    created() {
    }
}
</script>

<style lang="postcss">

/* 公用user样式 */
.ig--content-user {
    overflow: hidden;
    .user-avatar {
        width: 57px;
        height: 57px;
        margin-right: 20px;
        border-radius: 50%;
    }
    .user-file {
        .file-up {
            margin-top: 5px;
            margin-bottom: 10px;
            .file-name {
                font-size: 24px;
                margin-right: 10px;
            }
            .ig--tag {
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                height: 24px;
                margin-left: 8px;
                padding: 0 8px;
                border: 1px solid;
                border-radius: 2px;
                font-size: 18px;
            }
            .file-level {
                font-size: 20px;
            }
        }
        .file-down{
            margin-bottom: 3px;
            font-size: 18px;
        }
    }
}


</style>